export default "__VITE_ASSET__tXe0cfwS__"